export const inactiveStudentDataAnalytcsTableHead = [
  {
    headerName: 'Sl No.',
    field: 'slNo',
    sortable: true,
    width: 80,
  },
  {
    headerName: 'CRO Name',
    field: 'croName',
    sortable: true,
    width: 160,
  },
  {
    headerName: 'Total Inactive Students',
    field: 'totalInactiveStudents',
    sortable: true,
    width: 200,
  },
  {
    headerName: 'Admission Confirmed',
    field: 'admissionConfirmed',
    sortable: true,
    width: 190,
  },
  {
    headerName: 'Postponed',
    field: 'postponed',
    sortable: true,
    width: 140,
  },
  {
    headerName: 'Fee Issue',
    field: 'feeIssue',
    sortable: true,
    width: 130,
  },
  {
    headerName: 'Not Needed Now',
    field: 'notNeededNow',
    sortable: true,
    width: 170,
  },
  {
    headerName: 'No Course to Enroll',
    field: 'noCourseToEnroll',
    sortable: true,
    width: 190,
  },
  {
    headerName: 'Not Attended',
    field: 'notAttended',
    sortable: true,
    width: 160,
  },
];
